/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AggregierteAuswertungLayoutDto } from '../../models/aggregierte-auswertung-layout-dto';

export interface GetAllAggregierteAuswertungLayouts$Plain$Params {
}

export function getAllAggregierteAuswertungLayouts$Plain(http: HttpClient, rootUrl: string, params?: GetAllAggregierteAuswertungLayouts$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregierteAuswertungLayoutDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllAggregierteAuswertungLayouts$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AggregierteAuswertungLayoutDto>>;
    })
  );
}

getAllAggregierteAuswertungLayouts$Plain.PATH = '/v1/aggregierteAuswertung/layouts';
